// HeroSection.jsx
import React from "react";
import { Box, Typography } from "@mui/material";
import { keyframes } from "@emotion/react";
import userimage from "../Assets/Images/user.png";

const float = keyframes`
  0%   { transform: translateY(0px); }
  50%  { transform: translateY(-14px); }
  100% { transform: translateY(0px); }
`;

export default function HeroSection() {
  return (
    <Box
      sx={{
        pt: { xs: 10, md: 12 },   // 🔽 reduced
        pb: { xs: 6, md: 8 },     // 🔽 reduced
        backgroundColor: "#f1ede4", // 🔥 slightly darker than before
        position: "relative",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          maxWidth: 1300,
          mx: "auto",
          px: { xs: 2, md: 3 },
          position: "relative",
          minHeight: { xs: 360, md: 460 }, // 🔽 reduced
        }}
      >
        {/* BACKGROUND TEXT */}
        <Box
          sx={{
            position: "absolute",
            top: { xs: 0, md: -60 }, // 🔽 adjusted
            left: "50%",
            transform: "translateX(-50%)",
            width: "100%",
            textAlign: "center",
            zIndex: 1,
            pointerEvents: "none",
          }}
        >
          <Typography
            sx={{
              fontSize: { xs: "12.5vw", sm: "10vw", md: "8.5vw" },
              fontWeight: 800,
              color: "#2ca24b",
              textTransform: "lowercase",
              letterSpacing: "-0.03em",
              lineHeight: 1,
              whiteSpace: { xs: "normal", md: "nowrap" },
            }}
          >
            Water Restoration
          </Typography>
        </Box>

        {/* FLOATING LEFT BUBBLE */}
        <Box
          component="img"
          src="https://qleen.bold-themes.com/demo-01/wp-content/uploads/sites/2/2025/07/floating_image_02.png"
          sx={{
            position: "absolute",
            left: { xs: -80, md: -60 },
            top: { xs: 110, md: 120 },
            width: { xs: 150, md: 210 },
            animation: `${float} 7s ease-in-out infinite`,
            zIndex: 2,
          }}
        />

        {/* FLOATING RIGHT BUBBLE */}
        <Box
          component="img"
          src="https://qleen.bold-themes.com/demo-01/wp-content/uploads/sites/2/2025/07/floating_image_02.png"
          sx={{
            position: "absolute",
            right: { xs: -80, md: -60 },
            top: { xs: 90, md: 110 },
            width: { xs: 150, md: 210 },
            animation: `${float} 8s ease-in-out infinite`,
            animationDelay: "0.6s",
            zIndex: 2,
          }}
        />

        {/* MAIN HERO IMAGE */}
        <Box
          sx={{
            position: "relative",
            zIndex: 3,
            display: "flex",
            justifyContent: "center",
            mt: { xs: 6, md: 4 }, // 🔽 reduced
          }}
        >
          <Box
            component="img"
            src={userimage}
            alt="Rite Water Mitigation professional"
            sx={{
              width: { xs: "75%", sm: "58%", md: "36%" },
              maxWidth: 460,
              height: "auto",
              filter: "drop-shadow(0 18px 36px rgba(0,0,0,0.18))",
            }}
          />
        </Box>
      </Box>
    </Box>
  );
}
